import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CertificateTypeModel } from '@models/configuration/certificate-type.model';
import { Store } from '@ngrx/store';
import * as fromAppRoot from '@reducers/index';
import { TableStorageActionModel } from '@models/common/table-storage-action.model';
import { Partitions } from '@root/core/enums/partition.enum';
import { FacadeInterface } from '@interfaces/facade-interface';
import { CertificateTypeActions } from '@actions/configuration';

@Injectable({
  providedIn: 'root'
})
export class CertificateTypeFacadeService implements FacadeInterface<CertificateTypeModel> {

  getAll$(): Observable<CertificateTypeModel[]> {
    return this.store.select(fromAppRoot.getCertificateTypes)
  }

  getCurrentItem$(): Observable<CertificateTypeModel> {
    return this.store
      .select(fromAppRoot.getCurrentCertificateType);
  }

  search(): void {
    const props: TableStorageActionModel<CertificateTypeModel> = {
      queryParams: `${Partitions.CERTIFICATETYPE}/GetAll`,
    }
    this.store.dispatch(CertificateTypeActions.searchCertificateTypes({ action: props }));
  }

  create(payload: CertificateTypeModel): void {
    const props: TableStorageActionModel<CertificateTypeModel> = {
      queryParams: `${Partitions.CERTIFICATETYPE}/Post`,
      payload
    }
    this.store.dispatch(CertificateTypeActions.createCertificateType({ action: props }));
  }

  update(payload: CertificateTypeModel): void {
    const action: TableStorageActionModel<CertificateTypeModel> = {
      queryParams: `${Partitions.CERTIFICATETYPE}/Post`,
      payload
    }
    this.store.dispatch(CertificateTypeActions.updateCertificateType({ action }));
  }

  select(CertificateType: CertificateTypeModel): void {
    this.store.dispatch(CertificateTypeActions.selectCertificateType({ CertificateType }));
  }

  delete(payload: CertificateTypeModel): void {
    const props: TableStorageActionModel<CertificateTypeModel> = {
      queryParams: `${Partitions.CERTIFICATETYPE}/Delete?id=`+payload.id,
      payload
    }
    this.store.dispatch(CertificateTypeActions.deleteCertificateType({ action: props }));
  }

  reset(): void {
  }

  resetSelected(): void {
  }

  constructor(
    private store: Store<fromAppRoot.State>,
  ) { }

}
